import './Dashboard.scss'

import {CaretDownFilled, CheckCircleTwoTone, CloseCircleTwoTone} from '@ant-design/icons'
import { Button, Collapse, Modal, notification, Select, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { saveAs } from 'file-saver'
import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as XLSX from 'xlsx'

import {
  useAdminSiniflarQuery,
  useDersListesiOnayDurumuGuncelleMutation,
  useKategoriHiyerarsisiQuery,
} from '../../../../gql/GeneratedGraphqlTypes'
import { getFormattedPrice } from '../../../../helpers/Formatting'
import Spinner from '../../../spinner/Spinner'
import { ReactComponent as ExcelIcon } from '../pages-icons/excel.svg'

const { Option } = Select
const { Panel } = Collapse
const Dashboard: React.FC = () => {
  const selectedSubeRef = useRef<number | null>(null)
  const selectedKategoriRef = useRef<number | null>(null)
  const selectedAltKategoriRef = useRef<number | null>(null)
  const navigate = useNavigate()
  const [selectedSube, setSelectedSube] = useState<number | null>(null)
  const [kategoriListesi, setKategoriListesi] = useState<any[]>([])
  const [selectedKategori, setSelectedKategori] = useState<number | null>(null)
  const [selectedAltKategori, setSelectedAltKategori] = useState<number | null>(null)
  const [altKategoriListesi, setAltKategoriListesi] = useState<any[]>([])
  const [adminSiniflar, setAdminSiniflar] = useState<any>(null)
  const [groupedData, setGroupedData] = useState<any[]>([])
  const [dynamicCategories, setDynamicCategories] = useState<any[]>([])
  const [modalVisible, setModalVisible] = useState<boolean>(false)
  const [selectedDersler, setSelectedDersler] = useState<any[]>([])
  const [modalTitle, setModalTitle] = useState('')
  const [dersListesOnayDurumuGuncelleMutation] = useDersListesiOnayDurumuGuncelleMutation()
  const { data, loading, error } = useKategoriHiyerarsisiQuery({})
  const [isApprovalModalVisible, setIsApprovalModalVisible] = useState(false)
  const [isApprovalCancelModalVisible, setIsApprovalCancelModalVisible] = useState(false)
  const [isApprovalAllModalVisible, setIsApprovalAllModalVisible] = useState(false)
  const [isApprovalCancelAllModalVisible, setIsApprovalCancelAllModalVisible] = useState(false)
  const [selectedSinif, setSelectedSinif] = useState<number[]>([]) // Liste olarak tanımlandı

  const {
    data: adminSiniflarData,
    loading: adminSiniflarLoading,
    refetch,
  } = useAdminSiniflarQuery({
    variables: { sinif_kategorisi_id: selectedAltKategori || selectedKategori || 0 },
    skip: true,
    fetchPolicy: 'no-cache', // Her zaman sunucudan veri al
  })

  useEffect(() => {
    const fetchData = async () => {
      if (selectedAltKategori || selectedKategori) {
        try {
          const response = await refetch({
            sinif_kategorisi_id: selectedAltKategori || selectedKategori || 0,
          })
          if (response.data) {
            setAdminSiniflar(response.data)
          }
        } catch (error) {
          console.error('Refetch Error:', error, adminSiniflarData)
        }
      }
    }
    fetchData()
  }, [selectedAltKategori, selectedKategori, adminSiniflarData, refetch])

  useEffect(() => {
    if (adminSiniflar?.adminSiniflar?.admin_sinif_dersler) {
      const sortedSiniflar = [...adminSiniflar.adminSiniflar.admin_sinif_dersler].sort((a: any, b: any) =>
          a.sinif_isim.trim().localeCompare(b.sinif_isim.trim(), 'tr', { numeric: true, sensitivity: 'base' }),
      )

      const newGroupedData = sortedSiniflar.map((sinif: any) => {
        // 👇 sadece geçerli ürün adı olan dersleri al

        const groupedDersler = sinif.dersler
            .reduce((acc: any, ders: any) => {
              const existingDers = acc.find((item: any) => item.ders_isim === ders.ders_isim)
              if (existingDers) {
                existingDers.adet += ders.adet
                existingDers.toplam_fiyat += ders.adet * ders.etiket_fiyati
                existingDers._detaylar.push(ders)
              } else {
                acc.push({
                  ...ders,
                  toplam_fiyat: ders.adet * ders.etiket_fiyati,
                  _detaylar: [ders],
                })
              }
              return acc
            }, [])
          .sort((a: any, b: any) => a.ders_isim.localeCompare(b.ders_isim, 'tr', { sensitivity: 'base' }))

        return {
          ...sinif,
          dersler: groupedDersler,
        }
      })

      setGroupedData(newGroupedData)
    }
  }, [adminSiniflar])

  useEffect(() => {
    if (altKategoriListesi.length > 0) {
      setDynamicCategories([altKategoriListesi])
    }
  }, [altKategoriListesi])

  const closeModal = () => {
    setModalVisible(false)
    setSelectedDersler([])
  }

  const handleDetayGor = (ders: any) => {
    const detayList = ders._detaylar?.length ? ders._detaylar : [ders]
    console.log("Görüntülenen detay listesi:", detayList)
    
    setSelectedDersler(detayList)
    setModalTitle(`${detayList[0].sinif_adi} - ${detayList[0].ders_isim} Dersi Sınıf Listesi:`)
    setModalVisible(true)
  }

  if (loading) {
    return <Spinner showSpinner={true} color="red" />
  }

  if (loading || adminSiniflarLoading) {
    return <Spinner showSpinner={true} color="red" />
  }

  if (loading) {
    return <Spinner showSpinner={loading} color="red" />
  }

  if (error) {
    console.error(error)
    navigate('/')
    return null
  }

  const totalPrice =
    adminSiniflar?.adminSiniflar?.admin_sinif_dersler.reduce((acc: any, item: any) => {
      const derslerToplami = item!.dersler.reduce(
        (dersAcc: number, ders: any) => dersAcc + (ders.etiket_fiyati || 0) * (ders.adet || 0),
        0,
      )
      return acc + derslerToplami
    }, 0) || 0

  const totalProducts = new Set(
      adminSiniflar?.adminSiniflar?.admin_sinif_dersler
          .flatMap((sinif: any) => sinif.dersler)
          .filter((ders: any) => ders.urun_isim && ders.urun_isim.trim() !== '')
          .map((ders: any) => ders.urun_isim),
  ).size

  const subeler = (data?.kategoriHiyerarsisi?.yetkili_subeler || [])
    .slice() // Yeni bir dizi kopyası oluşturur
    .sort((a, b) => (a?.isim || '').localeCompare(b?.isim || '', 'tr', { sensitivity: 'base' }))

  const kategoriler = (data?.kategoriHiyerarsisi?.kategori_hiyerarsisi || [])
    .slice() // Yeni bir dizi kopyası oluşturur
    .sort((a, b) => (a?.isim || '').localeCompare(b?.isim || '', 'tr', { sensitivity: 'base' }))

  const handleSubeChange = (value: number) => {
    setSelectedSube(value) // Seçilen şubeyi güncelle
    setSelectedKategori(null)
    setSelectedAltKategori(null)
    selectedSubeRef.current = value // Referansı güncelle
    const filteredKategoriler = kategoriler.filter((kategori: any) => kategori.sube_id === value)
    setKategoriListesi(filteredKategoriler) // Şubeye göre kategorileri güncelle
    setAltKategoriListesi([]) // Alt kategori listesini sıfırla
    setDynamicCategories([])
  }

  const handleKategoriChange = (value: number) => {
    setSelectedKategori(value)
    setSelectedAltKategori(null)
    selectedKategoriRef.current = value // Değeri sakla
    const selectedKategori = kategoriListesi.find((kategori: any) => kategori.id === value)
    const sortedAltKategoriler = (selectedKategori?.alt_kategoriler || [])
      .slice()
      .sort((a: any, b: any) => (a.isim || '').localeCompare(b.isim || '', 'tr', { sensitivity: 'base' }))
    setAltKategoriListesi(sortedAltKategoriler)
    setDynamicCategories([])
  }

  const handleAltKategoriChange = (value: number, level: number) => {
    // Seçilen alt kategoriyi bul
    const selectedAltKategori = dynamicCategories[level]?.find((altKategori: any) => altKategori.id === value)
    // setSelectedAltKategori(value) // Seçilen alt kategoriyi güncelle
    selectedAltKategoriRef.current = value // Referansı güncelle

    if (selectedAltKategori?.alt_kategoriler?.length) {
      // Alt kategoriler varsa, onları sıralayıp dinamik kategorilere ekle
      const sortedAltKategoriler = selectedAltKategori.alt_kategoriler
        .slice()
        .sort((a: any, b: any) => (a.isim || '').localeCompare(b.isim || '', 'tr', { sensitivity: 'base' }))

      setDynamicCategories((prev) => {
        const newCategories = [...prev]
        newCategories[level + 1] = sortedAltKategoriler // Bir sonraki seviyeyi ekle
        return newCategories.slice(0, level + 2) // O seviyeden sonrasını sıfırla
      })
    } else {
      // Alt kategoriler yoksa sadece o seviyeden sonrasını temizle
      setDynamicCategories((prev) => prev.slice(0, level + 1))
    }
  }

  const columns: ColumnsType<any> = [
    {
      title: 'Ürün',
      dataIndex: 'resim_url',
      key: 'resim_url',
      render: (value: string, record: any) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img height={70} width={50} src={value} alt="Ürün Resmi" className="product-image" />
        </div>
      ),
    },
    {
      title: 'Ürün İsim',
      dataIndex: 'urun_isim',
      key: 'urun_isim',
    },
    {
      title: 'Öğretmen',
      dataIndex: 'ogretmen_adi',
      key: 'ogretmen_adi',
    },
    {
      title: 'Onay Durumu',
      dataIndex: 'sinif_ders_aktif',
      key: 'sinif_ders_aktif',
      render: (value: boolean) => (
          value ? (
              <CheckCircleTwoTone twoToneColor="#52c41a" />
          ) : (
              <CloseCircleTwoTone twoToneColor="#ff4d4f" />
          )
      ),
    },
    {
      title: 'Adet',
      dataIndex: 'adet',
      key: 'adet',
    },
    {
      title: 'Fiyat',
      dataIndex: 'etiket_fiyati',
      key: 'etiket_fiyati',
      render: (value: number) => `${value.toLocaleString('tr-TR')}`,
    },
  ]

  const showApprovalModal = (sinifDersIdList: number[]) => {
    setSelectedSinif(sinifDersIdList)
    setIsApprovalModalVisible(true)
  }

  const showApprovalCancelModal = (sinifDersIdList: number[]) => {
    setSelectedSinif(sinifDersIdList)
    setIsApprovalCancelModalVisible(true)
  }

  const showApprovalAllModal = (sinif: any) => {
    // sadece sinif_ders_aktif değeri false olanları al
    const sinifDersIds = sinif.dersler
        .flatMap((d: any) => d._detaylar?.length ? d._detaylar : [d])
        .filter((d: any) => !d.sinif_ders_aktif)
        .map((d: any) => d.sinif_ders_id)

    setSelectedSinif(sinifDersIds) // State'e güncelle
    setIsApprovalAllModalVisible(true) // Modalı göster
  }

  const showApprovalCancelAllModal = (sinif: any) => {
    const sinifDersIds = sinif.dersler
        .flatMap((d: any) => d._detaylar?.length ? d._detaylar : [d])
        .map((d: any) => d.sinif_ders_id)
    setSelectedSinif(sinifDersIds)
    setIsApprovalCancelAllModalVisible(true)
  }

  const handleSendApproval = async () => {
    const uniqueSelectedSinif = Array.from(new Set(selectedSinif)); // Tekilleştiriyoruz
    try {
      const response = await dersListesOnayDurumuGuncelleMutation({
        variables: {
          input: {
            sinifdersi_ids: uniqueSelectedSinif!,
          },
        },
      })
      if (response.data?.dersListesiOnayDurumuGuncelle.success) {
        notification.success({
          message: 'Onay Durumu Güncellendi',
          description: `${response.data?.dersListesiOnayDurumuGuncelle?.message}`,
          duration: 6,
        })
        const refetchadData = await refetch({
          sinif_kategorisi_id: selectedAltKategori || selectedKategori || 0,
        })
        if (refetchadData.data) {
          setAdminSiniflar(refetchadData.data)
          setSelectedSinif([])
        }
      } else {
        notification.error({
          message: '',
          description: `${response.data?.dersListesiOnayDurumuGuncelle?.message || 'Bir hata oluştu'}`,
          duration: 6,
        })
      }
    } catch (error) {
      notification.error({
        message: '',
        description: 'Listeyi gönderirken bir hata oluştu.',
        duration: 6,
      })
    } finally {
      setIsApprovalModalVisible(false)
      setIsApprovalCancelModalVisible(false)
      setIsApprovalCancelAllModalVisible(false)
      setIsApprovalAllModalVisible(false)
    }
  }

  const exportAllToExcel = () => {
    const worksheetData: any[] = []

    // Başlıklar
    const headers = [
      'Sınıf',
      'Ders',
      'Ürün Adı',
      'Birim Fiyat',
      'Barkod',
      'Adet',
      'Kategori',
      'Alt Kategori',
      'Marka',
      'Sınıf Not',
      'Oluşturulma Tarihi',
    ]
    worksheetData.push(headers)

    // Veriyi sınıf ve ders düzeyinde işleme
    adminSiniflar?.adminSiniflar?.admin_sinif_dersler.forEach((sinifDetay: any) => {
      // Ders detaylarını ekle, her satıra sınıf adını dahil et
      sinifDetay.dersler.forEach((ders: any) => {
        if (ders.urun_isim) {
          worksheetData.push([
            sinifDetay.sinif_isim, // Sınıf adı her satıra ekleniyor
            ders.ders_isim,
            ders.urun_isim || '',
            ders.etiket_fiyati ? ders.etiket_fiyati.toLocaleString('tr-TR') : '',
            ders.barcode,
            ders.adet || '',
            ders.kategori,
            ders.alt_kategori,
            ders.yayinevi,
            ders.sinif_not,
            ders.olusturma_tarihi,
          ])
        }
      })
    })

    // Excel'e yazma işlemleri
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

    // Kolon genişliklerini ayarla
    const colWidths = worksheetData[0].map((_: string, colIndex: number) =>
      Math.max(...worksheetData.map((row) => (row[colIndex] ? row[colIndex].toString().length : 10))),
    )
    worksheet['!cols'] = colWidths.map((width: number) => ({ wch: width }))

    // Çalışma kitabı oluştur ve indir
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'TümVeriler')
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    saveAs(new Blob([excelBuffer]), `tümsiniflar.xlsx`)
  }

  const exportSingleClassToExcel = (sinif: any) => {
    const worksheetData: any[] = []

    // Başlıklar
    const headers = [
      'Sınıf',
      'Ders',
      'Ürün Adı',
      'Birim Fiyat',
      'Barkod',
      'Adet',
      'Kategori',
      'Alt Kategori',
      'Marka',
      'Sınıf Not',
      'Oluşturulma Tarihi',
    ]
    worksheetData.push(headers)

    // İlgili sınıfı adminSiniflar içinden bul
    const matchedSinif = adminSiniflar?.adminSiniflar?.admin_sinif_dersler.find(
      (s: any) => s.sinif_id === sinif.sinif_id,
    )

    if (!matchedSinif) {
      console.error('Sınıf eşleşmedi!')
      return
    }

    // Her dersi kontrol et ve içindeki ürünleri ayrı ayrı ekle
    matchedSinif.dersler.forEach((ders: any) => {
      if (ders.urunler && ders.urunler.length > 0) {
        // Dersin içinde birden fazla ürün varsa, her ürünü ayrı satıra ekleyelim
        ders.urunler.forEach((urun: any) => {
          if (urun.adet > 0) {
            worksheetData.push([
              matchedSinif.sinif_isim, // Sınıf adı
              ders.ders_isim, // Ders adı
              urun.urun_isim, // Ürün adı
              urun.etiket_fiyati ? urun.etiket_fiyati.toLocaleString('tr-TR') : '',
              urun.barcode,
              urun.adet || '',
              urun.kategori,
              urun.alt_kategori,
              urun.yayinevi,
              urun.sinif_not,
              urun.olusturma_tarihi,
            ])
          }
        })
      } else {
        // Eğer dersin içinde ürünler dizisi yoksa veya tek ürün varsa
        if (ders.adet > 0) {
          worksheetData.push([
            matchedSinif.sinif_isim,
            ders.ders_isim,
            ders.urun_isim || '',
            ders.etiket_fiyati ? ders.etiket_fiyati.toLocaleString('tr-TR') : '',
            ders.barcode,
            ders.adet || '',
            ders.kategori,
            ders.alt_kategori,
            ders.yayinevi,
            ders.sinif_not,
            ders.olusturma_tarihi,
          ])
        }
      }
    })

    // Eğer hiç uygun ürün eklenmediyse işlemi durdur
    if (worksheetData.length === 1) {
      console.warn('Tüm ürünlerin adeti 0 olduğundan dışa aktarım yapılmadı.')
      return
    }

    // Excel'e yazma işlemleri
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)

    // Kolon genişliklerini ayarla
    const colWidths = worksheetData[0].map((_: string, colIndex: number) =>
      Math.max(...worksheetData.map((row) => (row[colIndex] ? row[colIndex].toString().length : 10))),
    )
    worksheet['!cols'] = colWidths.map((width: number) => ({ wch: width }))

    // Çalışma kitabı oluştur ve indir
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sınıf')
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    saveAs(new Blob([excelBuffer]), `${matchedSinif.sinif_isim}.xlsx`)
  }

  const getModalTotalPrice = () => {
    return selectedDersler.reduce((acc: number, ders: any) => {
      return acc + (ders.etiket_fiyati || 0) * (ders.adet || 0)
    }, 0)
  }

  const getModalTotalKdvPrice = () => {
    return selectedDersler.reduce((acc: number, ders: any) => {
      return acc + (ders.etiket_fiyati || 0) * (ders.adet || 0) * (ders.kdv_orani || 0)
    }, 0)
  }

  // **KDV Dahil Toplam**
  const getModalTotalWithKdv = () => {
    return getModalTotalPrice() + getModalTotalKdvPrice()
  }

  return (
    <div className="dashboard">
      <div className="okul-sepeti-admin-header">
        <h1>Dashboard</h1>
      </div>
      {/* Genel Başlık ve Filtreleme */}
      <div className="filter-container">
        {/* Şube Seçimi */}
        <div className="filter-container-content">
          <span className="filter-title">Kampüs/Sınıf Seviyesi</span>
          <Select
            suffixIcon={
              <>
                Değiştir <CaretDownFilled />
              </>
            }
            size="large"
            placeholder="Şube Seçiniz"
            className="sube-filter-select"
            onChange={handleSubeChange}
          >
            {subeler.map((sube: any) => (
              <Option key={sube.id} value={sube.id}>
                {sube.isim}
              </Option>
            ))}
          </Select>
        </div>
        {selectedSube && kategoriListesi.length > 0 && (
          <div className="filter-container-content">
            <span className="filter-title">Sınıf Kategorisi</span>
            {/* Kategori Seçimi */}
            <Select
              size="large"
              suffixIcon={
                <>
                  Değiştir <CaretDownFilled />
                </>
              }
              placeholder="Kategori Seçiniz"
              className="kategori-filter-select"
              onChange={handleKategoriChange}
              value={selectedAltKategori || undefined} // Kategori seçimini kontrol edilebilir hale getir
            >
              {kategoriListesi.map((kategori: any) => (
                <Option key={kategori.id} value={kategori.id}>
                  {kategori.isim}
                </Option>
              ))}
            </Select>
          </div>
        )}
        {dynamicCategories.map((categoryList, level) => (
          <div className="filter-container-content">
            <span className="filter-title">Sınıf - Sınıf Kategorisi</span>
            {/* Alt Kategori Seçimi */}
            <Select
              key={level}
              size="large"
              suffixIcon={
                <>
                  Değiştir <CaretDownFilled />
                </>
              }
              placeholder={`Seçim ${level + 1}`}
              className="sub-category-filter-select"
              onChange={(value) => handleAltKategoriChange(value, level)}
            >
              {categoryList.map((category: any) => (
                <Option key={category.id} value={category.id}>
                  {category.isim}
                </Option>
              ))}
            </Select>
          </div>
        ))}
      </div>
      <div className="header-card">
        <div className="header-card-title first-title">
          <span> Toplam Sınıf</span>
          <span>{groupedData.length}</span>
        </div>
        <div className="header-card-title second-title">
          <span> Toplam Ürün Çeşidi </span>
          <span> {totalProducts}</span>
        </div>
        <div className="header-card-title third-title">
          <span>Toplam Sepet Tutarı</span>
          <span>{totalPrice.toLocaleString('tr-TR')}₺</span>
        </div>
        <div className="fourth-title">
          <Button className="export-all-btn" onClick={exportAllToExcel}>
            Tümünü Excel'e Aktar <ExcelIcon />
          </Button>
        </div>
      </div>

      {/* Tablo Bölgesi */}
      <div className="table-container-admin">
        <Collapse bordered={false} defaultActiveKey={'1'}>
          {groupedData.map((sinif: any) => {
            const allActive = sinif.dersler.every((ders: any) => ders.sinif_ders_aktif)
            // const allDersler =
            //   adminSiniflar?.adminSiniflar?.admin_sinif_dersler.flatMap((sinif: any) => sinif.dersler) || []
            // const matchedDersler = allDersler.filter((ders: any) => ders.sinif_id === sinif.sinif_id)
            const uniqueProducts = new Set(
                sinif.dersler.flatMap((d: any) =>
                    (d._detaylar?.length ? d._detaylar : [d])
                        .filter((x: any) => x.urun_isim && x.urun_isim.trim() !== '' && (x.adet ?? 0) > 0)
                        .map((x: any) => x.urun_isim.trim()),
                ),
            ).size

            return (
              <Panel
                key={sinif.sinif_id}
                className="class-table-panel"
                header={
                  <div className="panel-content">
                    <div className="content content-class">
                      <span className="class-name-title">{sinif.sinif_isim}</span>
                    </div>
                    <div className="content">
                      <span className="span-title">Ürün Çeşidi</span>
                      <span className="bold-span">{uniqueProducts}</span>
                    </div>
                    <div className="content">
                      <span className="span-title">Sepet Tutarı</span>
                      <span className="bold-span">{getFormattedPrice(sinif.toplam_fiyat)}₺</span>
                    </div>

                    <div className="content-btn">
                      <Button
                        className="export-btn"
                        onClick={(event) => {
                          event.stopPropagation()
                          exportSingleClassToExcel(sinif)
                        }}
                      >
                        Excel'e Aktar <ExcelIcon />
                      </Button>
                      {allActive ? (
                        <Button
                          className="cancel-all-btn"
                          style={{ marginRight: 5 }}
                          onClick={(event) => {
                            event.stopPropagation()
                            showApprovalCancelAllModal(sinif)
                          }}
                        >
                          Onay Kaldır
                        </Button>
                      ) : (
                        <Button
                          className="accept-all-btn"
                          style={{ marginRight: 5 }}
                          onClick={(event) => {
                            event.stopPropagation()
                            showApprovalAllModal(sinif)
                          }}
                        >
                          Tümünü Onayla
                        </Button>
                      )}
                    </div>
                  </div>
                }
              >
                <Table
                  dataSource={sinif.dersler || []}
                  pagination={false}
                  className="collapse-table"
                  bordered={false}
                  columns={[
                    { title: 'Ders', dataIndex: 'ders_isim', key: 'ders_isim', width: '25%' },
                    {
                      title: 'Ürün Çeşidi',
                      dataIndex: 'adet',
                      key: 'adet',
                      align: 'center',
                      width: '25%',
                      render: (_: any, record: any) => {
                        const detaylar = record._detaylar?.length ? record._detaylar : [record]

                        const uniqueProducts = new Set(
                            detaylar
                                .filter((x: any) => x.urun_isim && x.urun_isim.trim() !== '' && (x.adet ?? 0) > 0)
                                .map((x: any) => x.urun_isim.trim()),
                        ).size

                        return uniqueProducts
                      },
                    },
                    {
                      title: 'Fiyat',
                      dataIndex: 'toplam_fiyat',
                      key: 'toplam_fiyat',
                      align: 'center',
                      width: '25%',
                      render: (value: number) => `${value.toLocaleString('tr-TR')} TL`,
                    },
                    {
                      title: 'İşlem',
                      key: 'action',
                      width: '25%',
                      render: (_: any, record: any) => (
                        <div className="table-action-buttons">
                          <Button className="detail-button" type="link" onClick={() => handleDetayGor(record)}>
                            Detay Gör
                          </Button>
                          {record._detaylar?.every((d: any) => d.sinif_ders_aktif) ? (
                              <Button
                                  className="cancel-button"
                                  onClick={() => showApprovalCancelModal(record._detaylar.map((d: any) => d.sinif_ders_id))}
                              >
                                Onay Kaldır
                              </Button>
                          ) : (
                              <Button
                                  className="accept-button"
                                  onClick={() =>
                                      showApprovalModal(
                                          record._detaylar.filter((d: any) => !d.sinif_ders_aktif).map((d: any) => d.sinif_ders_id)
                                      )
                                  }
                              >
                                Onayla
                              </Button>
                          )}
                        </div>
                      ),
                    },
                  ]}
                />
              </Panel>
            )
          })}
        </Collapse>
      </div>
      <Modal
        width={800}
        title={
          <div className="detail-modal-title">
            <span className="modal-title-span">{modalTitle}</span>
          </div>
        }
        open={modalVisible}
        onCancel={closeModal}
        footer={
          <div className="admin-detail-modal-footer">
            <div className="footer-price-content">
              <div className="footer-price-content-item">
                <span> Sepet Tutarı</span>
                <span> {getModalTotalPrice().toLocaleString('tr-TR')} TL</span>
              </div>
              <div className="footer-price-content-item">
                <span> Kdv Tutarı</span>
                <span> {getModalTotalKdvPrice().toLocaleString('tr-TR')} TL</span>
              </div>
              <div className="footer-price-content-item">
                <span>Kdv Dahil Toplam</span>
                <span> {getModalTotalWithKdv().toLocaleString('tr-TR')} TL</span>
              </div>
            </div>
            <Button className="admin-detail-modal-footer-btn" onClick={closeModal}>
              Kapat
            </Button>
          </div>
        }
      >
        {selectedDersler.length > 0 ? (
          <Table
            dataSource={selectedDersler}
            columns={columns}
            rowClassName={(record, index) =>
              index % 2 === 0 ? 'table-row-light admin-detail-modal' : 'table-row-dark admin-detail-modal'
            }
            className="collapse-table"
            bordered={false}
            pagination={false}
          />
        ) : (
          <div style={{ textAlign: 'center', padding: '20px', fontSize: '16px', color: '#666' }}>
            Bu sınıf dersine ürün kaydı yapılmamıştır.
          </div>
        )}
      </Modal>
      <Modal
        title="Sınıf Dersini Onayla"
        open={isApprovalModalVisible}
        onOk={handleSendApproval}
        onCancel={() => setIsApprovalModalVisible(false)}
        okText="Onayla"
        cancelText="Vazgeç"
      >
        <p>Bu sınıfın derslerini onaylamak istiyorum.</p>
      </Modal>
      <Modal
        title="Sınıf Dersinin Onayını Kaldır"
        open={isApprovalCancelModalVisible}
        onOk={handleSendApproval}
        onCancel={() => setIsApprovalCancelModalVisible(false)}
        okText="Onay Kaldır"
        cancelText="Vazgeç"
      >
        <p>Bu sınıfın derslerinin onayını kaldırmak istiyorum.</p>
      </Modal>
      <Modal
        title="Sınıfı Onayla"
        open={isApprovalAllModalVisible}
        onOk={handleSendApproval}
        onCancel={() => setIsApprovalAllModalVisible(false)}
        okText="Onayla"
        cancelText="Vazgeç"
      >
        <p>Bu sınıfın tüm derslerini onaylamak istiyorum.</p>
      </Modal>
      <Modal
        title="Sınıfın Onayını Kaldır"
        open={isApprovalCancelAllModalVisible}
        onOk={handleSendApproval}
        onCancel={() => setIsApprovalCancelAllModalVisible(false)}
        okText="Onay Kaldır"
        cancelText="Vazgeç"
      >
        <p>Bu sınıfın tüm derslerinin onayını kaldırmak istiyorum.</p>
      </Modal>
    </div>
  )
}

export default Dashboard
